var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-kpi-pareto-chart"},[(_vm.buildings)?_c('BarChart',{attrs:{"chart-data":_vm.chartData,"options":_vm.options,"exportable":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }